// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

/**
 * Canonical sort direction values, matching the backend `sortOrder` wire
 * params and the Material UI table props.
 */
// TODO(#15056): Remove the .catch() once legacy ascending/descending
// bookmarks have aged out, after 2026-10-08.
export const sortDirectionSchema = z.enum(['asc', 'desc']).catch('asc');

export type SortDirection = z.infer<typeof sortDirectionSchema>;

export interface Sort<SortProperty extends string> {
  property: SortProperty;
  direction: SortDirection;
}

/**
 * Inverts the given sort direction.
 *
 * @param direction - The direction to invert.
 */
export function invert(direction: SortDirection): SortDirection {
  return direction === 'asc' ? 'desc' : 'asc';
}
